export const NPM_CACHE_DIR = 'npm';
export const PNPM_CACHE_BASE_DIR = 'pnpm';
export const PNPM_STORE_DIR = `${PNPM_CACHE_BASE_DIR}/store`;
export const PNPM_CACHE_DIR = `${PNPM_CACHE_BASE_DIR}/cache`;
export const YARN_CACHE_DIR = 'yarn';
export const YARN_GLOBAL_DIR = 'berry';
